import { Component, OnInit, Injector, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AppComponentBase } from '../../services/AppComponentBase';
import { QuotePanelsTabsList } from '../../enums/QuotePanelsTabs.list';
import { ChartDisplayMode } from '../../enums/ChartDisplayMode.list';
import { ChartLayoutModeService } from '../../services/chartLayoutMode/chartLayoutMode.service';
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import { TutorialPanelComponent } from '../tutorial-panel/tutorial-panel.component';
import { ShowCompetitionRegisterModal } from '../modals/competitionRegistration/show-competition-registration-modal';
import { MobileMainView } from '../../enums/mobile-mainViews';
import { DataService } from '../../services/data/data.service';

@Component( {
    selector: 'app-landingPage',
    template: require('./landingPage.component.html'),
    styles: [ require('./landingPage.component.css') ]
} )
export class LandingPageComponent extends AppComponentBase implements OnInit, AfterViewInit {

    @ViewChild( "landingPage" ) public landingPage!: ElementRef;

    constructor ( injector: Injector, public activeLayoutTypeService: ChartLayoutModeService, public dataService: DataService ) {
        super( injector );
    }

    ngOnInit () {


    }

    getFilteredTiles (): IlandingPage {
        let data: IlandingPage = Object.assign( {}, this.landingPageTiles );

        if ( !this.dataService.AllowScannerAccess ) {
            let scannerIndex = data.tiles.findIndex( x => x.label == "Scanner" );
            if ( scannerIndex > -1 ) {
                data.tiles.splice( scannerIndex, 1 );
            }

            let appIndex = data.tiles.findIndex( x => x.label == "App Store" );
            if ( appIndex > -1 ) {
                data.tiles.splice( appIndex, 1 );
            }
        }

        if ( this.workspace.mobileMode!="desktop" && !this.dataService.AllowScannerMobile ) {
            let scannerIndex = data.tiles.findIndex( x => x.label == "Scanner" );
            if ( scannerIndex > -1 ) {
                data.tiles.splice( scannerIndex, 1 );
            }

            let appIndex = data.tiles.findIndex( x => x.label == "App Store" );
            if ( appIndex > -1 ) {
                data.tiles.splice( appIndex, 1 );
            }
        }




        return data;
    }

    ngAfterViewInit () {

        setTimeout( () => {
            $( ".landingPageBox" ).mCustomScrollbar( {
                axis: "y",
                theme: "inset-3", // "minimal-dark",
                scrollbarPosition: "outside",
                alwaysShowScrollbar: 1, // 0,1,2
                snapAmount: 100,
                scrollButtons: {
                    enable: true
                },
                mouseWheel: {
                    enable: true,
                    deltaFactor: 200
                }
            } );
        }, 100 );
    }


    public landingPageTiles: IlandingPage = {
        tiles: [
            // {
            //     label: "Wizard",
            //     image: "/images/landing-page/Wizard.png?v=5",
            //     linkPage: null,
            //     premium: false,
            //     clickStateUpdate: {
            //         //  panel:QuotePanelsTabsList.SYMBOL,
            //         displayMode: ChartDisplayMode.WIZARD,
            //         //   chartGridMode:'4',
            //         showPanel: true
            //     }
            // },
            {
                label: "Charting",
                image: "/images/landing-page/Charting.png?v=5",
                linkPage: null,
                premium: false,
                clickStateUpdate: {
                    //   panel:QuotePanelsTabsList.SYMBOL,
                    displayMode: ChartDisplayMode.CHARTING,
                    //   chartGridMode:'4',
                    showPanel: true
                }
            },
            // {
            //     label: "Entry Signals",
            //     image: "/images/landing-page/Entry-Signals.png?v=5",
            //     linkPage: null,
            //     premium: false,
            //     clickStateUpdate: {
            //         //   panel:QuotePanelsTabsList.SYMBOL,
            //         displayMode: ChartDisplayMode.ENTSIGNALS,
            //         //   chartGridMode:'4',
            //         showPanel: true
            //     }
            // },
            // {
            //     label: "Monitor",
            //     image: "/images/landing-page/MONITOR.png?v=5",
            //     linkPage: null,
            //     premium: false,
            //     clickStateUpdate: {
            //         panel: QuotePanelsTabsList.MONITOR,
            //         //     displayMode:ChartDisplayMode.ENTSIGNALS,
            //         //    chartGridMode:'4',
            //         showPanel: true
            //     }
            // },
            {
                label: "Tradedesk",
                image: "/images/landing-page/Tradedesk.png?v=5",
                linkPage: null,
                premium: false,
                clickStateUpdate: {
                    //   panel:QuotePanelsTabsList.SYMBOL,
                    //    displayMode:ChartDisplayMode.WIZARD,
                    //    chartGridMode:'4',
                    showPanel: true,
                    showTradedesk: true
                }
            },
            // {
            //     label: "Scanner",
            //     image: "/images/landing-page/SCANNER.png?v=5",
            //     linkPage: null,
            //     premium: true,
            //     clickStateUpdate: {
            //         panel: QuotePanelsTabsList.SCANNER,
            //         //     displayMode:ChartDisplayMode.ENTSIGNALS,
            //         //    chartGridMode:'4',
            //         showPanel: true
            //     }
            // },
            // {
            //     label: "App Store",
            //     image: "/images/landing-page/App-Store-Logo.png?v=5",
            //     linkPage: null,
            //     premium: false,
            //     clickStateUpdate: {
            //     //    panel: QuotePanelsTabsList.SCANNER,
            //         //     displayMode:ChartDisplayMode.ENTSIGNALS,
            //         //    chartGridMode:'4',
            //       //  showPanel: true
            //       showAppStore: true
            //     }
            // },
            // {
            //     label: "Challenge",
            //     image: "/images/landing-page/New-PT-Challenges-Logo.png?v=5",
            //     linkPage: null,
            //     premium: false,
            //     clickStateUpdate: {
            //         panel: QuotePanelsTabsList.LEADERBOARD,
            //         //    displayMode:ChartDisplayMode.WIZARD,
            //         //     chartGridMode:'4',
            //         showPanel: true,
            //         showChallengeInfo: true
            //     }
            // },
         
            // {
            //     label: "TI Wizard",
            //     image: "/images/landing-page/TI-Wizard.png?v=5",
            //     linkPage: null,
            //     premium: false,
            //     clickStateUpdate: {
            //         panel: QuotePanelsTabsList.WIZARD,
            //         //   displayMode:ChartDisplayMode.WIZARD,
            //         //   chartGridMode:'1',
            //         showPanel: true
            //     }
            // },
            {
                label: "Baskets",
                image: "/images/landing-page/Baskets.png?v=5",
                linkPage: null,
                premium: false,
                clickStateUpdate: {
                    //   panel:QuotePanelsTabsList.SYMBOL,
                    //    displayMode:ChartDisplayMode.WIZARD,
                    //    chartGridMode:'4',
                    //   showPanel:true,
                    //    showTradedesk:true
                    activeBasket: true
                }
            },
            // {
            //     label: "Alerts",
            //     image: "/images/landing-page/alerts.png?v=6",
            //     linkPage: null,
            //     premium: true,
            //     clickStateUpdate: {
            //         panel: QuotePanelsTabsList.ALERTS,
            //         //    displayMode:ChartDisplayMode.WIZARD,
            //         //    chartGridMode:'4',
            //         showPanel: true
            //     }
            // },
            // {
            //     label: "Social",
            //     image: "/images/landing-page/Social.png?v=5",
            //     linkPage: null,
            //     premium: false,
            //     clickStateUpdate: {
            //         panel: QuotePanelsTabsList.SOCIAL,
            //         //  displayMode:ChartDisplayMode.WIZARD,
            //         //  chartGridMode:'4',
            //         showPanel: true
            //     }
            // },
            // {
            //     label: "Coaching",
            //     image: "/images/landing-page/Coaching.png?v=5",
            //     linkPage: "https://premieretrade.com/custom-coaching/",
            //     premium: true,
            //     clickStateUpdate: {
            //         panel: QuotePanelsTabsList.LEADERBOARD,
            //         displayMode: ChartDisplayMode.WIZARD,
            //         //   chartGridMode:'1',
            //     }
            // },
            // {
            //     label: "Quickstart",
            //     image: "/images/landing-page/1-Minute.png?v=5",
            //     linkPage: null,
            //     premium: false,
            //     clickStateUpdate: {
            //         panel: QuotePanelsTabsList.SYMBOL,
            //         displayMode: ChartDisplayMode.WIZARD,
            //         //   chartGridMode:'4',
            //         showTutorialPanel: true,
            //         showTutorialVideo: 'wa3aqbaede'
            //     }
            // },
        ]
    }

    public setState ( state: landingClickState, label: string ) {

        this.workspace.showLoaderComponent = true;
        this.workspace.currentLoadedTitle = label;
        this.workspace.showAppStore = false;
        window.location.hash = '#' + label.toLowerCase().replace( " ", "" );

        if ( state.activeBasket ) {
            this.workspace.activeBasket = 0;
            return;
        }

        if ( state.panel != undefined )
        {
            if(state.panel!=QuotePanelsTabsList.SCANNER)
             this.workspaceService.data.activeTab = state.panel;


             if(state.panel!='scanner')
             {
                 this.workspace.showScannerPage = false;
             }
             else
             {
                this.workspace.showScannerPage = true;
             }
        }
           

        if ( state.displayMode != undefined ) {
            this.workspace.chartDisplayMode = state.displayMode;
            this.workspace.showScannerPage = false;
            // this.activeLayoutTypeService.subscriber.next(state.chartGridMode);
        }

        this.workspace.showLandingPage = false;

        if ( state.showTutorialPanel == true )
            this.workspace.tutorialPanelShown = true;

        if ( state.showTutorialVideo != null )
            this.workspace.activeTutorialVideo = state.showTutorialVideo;

        if ( state.showPanel == true )
            this.showQuotePanel = state.showPanel


        if ( state.showChallengeInfo == true )
            this.showChallengeInfo();


        if ( state.showTradedesk != undefined )
        {
             this.workspace.showTradeDesk = state.showTradedesk;
             this.workspace.showScannerPage = false;
        }
           
        if(state.showAppStore == true)
        {
            this.workspace.showAppStoreAction();
        }
        //


    }


    public showChallengeInfo () {
        if ( this.workspace.getFirstChallenge !== undefined ) {

            // if(this.workspace.mobileMode!="desktop")
            // {        
            if ( this.cookieService.getCookie( "_challengeInfo_" + this.workspace.getFirstChallenge.id ) != "1" || !this.workspace.challengeWithUser ) {
                ShowCompetitionRegisterModal( this.modalService, this.workspace.getFirstChallenge, true, this.workspace.challengeWithUser, undefined, undefined, undefined, this.workspace.mobileMode );
            }
            this.cookieService.setCookie( "_challengeInfo_" + this.workspace.getFirstChallenge.id, "1", 1000, "/" );
            // }
            // else
            // {
            //   ShowCompetitionRegisterModal(this.modalService, this.workspace.getFirstChallenge, true, this.workspace.challengeWithUser, undefined, undefined, undefined, this.workspace.mobileMode);
            // }
        }
    }








    public get showQuotePanel () {
        return this.workspace.showQuotePanel;
    }

    public set showQuotePanel ( v: boolean ) {
        this.workspace.showQuotePanel = v;
    }

    public get containerHeight () {
        return this.landingPage.nativeElement.offsetHeight / 3;
    }

    public get containerWidth () {
        let colNum = 4;
        return (this.landingPage.nativeElement.offsetWidth - 20) / colNum;
    }



    public calculateBoxHeight () {

        let maxHeight = this.landingPage.nativeElement.offsetHeight;




        return {
            "height": "calc(100% + 60px)"
        };


    }


}


export interface IlandingPage {
    tiles: landingPageTile[];
}

export interface landingPageTile {
    image: string;
    label: string;
    premium: boolean,
    clickStateUpdate: landingClickState;
    linkPage: string | null;
}

export interface landingClickState {
    panel?: QuotePanelsTabsList;
    displayMode?: ChartDisplayMode;
    chartGridMode?: string;
    showTradedesk?: boolean;
    showPanel?: boolean
    showTutorialPanel?: boolean;
    showTutorialVideo?: string;
    showChallengeInfo?: boolean;
    activeMobileView?: MobileMainView
    activeBasket?: boolean;
    showTrainingPanel?: boolean;
    showAppStore?: boolean;
}